import { useCallback } from 'react';
import apiClient from '../../../api/axiosClient';
import { GetCampaignConfigsApiParams, DeleteCampaignConfigApiParams, CreateCampaignConfigApiParams, UpdateCampaignConfigApiParams } from './types';

/**
 * @function useGetCampaignConfigsApi
 * @returns { GetCampaignConfigsApiParams }
 */
export function useGetCampaignConfigsApi(): GetCampaignConfigsApiParams {
  return useCallback((params) => {
    return apiClient.get('/applications/campaign-configs', { params });
  }, []);
}

/**
 * @function useDeleteCampaignConfigApi
 * @returns { DeleteCampaignConfigApiParams }
 * Archives a single campaign config via the status endpoint.
 */
export function useDeleteCampaignConfigApi(): DeleteCampaignConfigApiParams {
  return useCallback((id) => {
    return apiClient
      .patch(`/applications/campaign-configs/${id}/status`, { status: 'archived' })
      .then(() => undefined);
  }, []);
}

/**
 * @function useCreateCampaignConfigApi
 * @returns { CreateCampaignConfigApiParams }
 */
export function useCreateCampaignConfigApi(): CreateCampaignConfigApiParams {
  return useCallback((data) => {
    return apiClient.post('/applications/campaign-configs', data);
  }, []);
}

/**
 * @function useUpdateCampaignConfigApi
 * @returns { UpdateCampaignConfigApiParams }
 */
export function useUpdateCampaignConfigApi(): UpdateCampaignConfigApiParams {
  return useCallback((id, data) => {
    return apiClient.put(`/applications/campaign-configs/${id}`, data);
  }, []);
}
